import { render, staticRenderFns } from "./AddEmployeeWelcomeComponent.vue?vue&type=template&id=892ae82a&"
import script from "./AddEmployeeWelcomeComponent.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeWelcomeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports